import { Icon } from "@iconify/react/dist/iconify.js";
import {
  HealthInsuranceButtonIcon,
  TravelInsuranceButtonIcon,
  TrafficInsuranceButtonIcon,
  DaskInsuranceButtonIcon,
  KaskoInsuranceButtonIcon,
  TourismInsuranceButtonIcon,
  TssInsuranceButtonIcon,
  OssInsuranceButtonIcon,
} from "../libs/SVGIcons";
import { OfflineStorage } from "./estrylib";

export const InsuranceTypesButtonsItems = [
  {
    id: 1,
    icon: <HealthInsuranceButtonIcon />,
    text: "Health",
  },
  {
    id: 2,
    icon: <TravelInsuranceButtonIcon />,
    text: "Travel",
  },
  {
    id: 3,
    icon: <DaskInsuranceButtonIcon />,
    text: "Dask",
  },
  {
    id: 4,
    icon: <TrafficInsuranceButtonIcon />,
    text: "Traffic",
  },
  {
    id: 5,
    icon: <KaskoInsuranceButtonIcon />,
    text: "Kasko",
  },
  {
    id: 6,
    icon: <TourismInsuranceButtonIcon />,
    text: "Tourism",
  },
  {
    id: 7,
    icon: <TssInsuranceButtonIcon />,
    text: "Tss",
  },
  {
    id: 8,
    icon: <OssInsuranceButtonIcon />,
    text: "Oss",
  },
];

export const KaskoIDTypeItems = [
  {
    id: 1,
    icon: <></>,
    text: "TC",
  },
  {
    id: 2,
    icon: <></>,
    text: "Tax",
  },
];

export const ForeignIdTypeItems = [
  {
    id: 1,
    icon: <></>,
    text: "Passport",
  },
  {
    id: 2,
    icon: <></>,
    text: "TC",
  },
];

export const GenderItems = [
  {
    id: 1,
    icon: <></>,
    text: "Male",
  },
  {
    id: 2,
    icon: <></>,
    text: "Female",
  },
];

export const TravelPolicyTermsItems = [
  {
    label: window.sys_app_translate(
      "7 Days",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "7days",
  },
  {
    label: window.sys_app_translate(
      "14 Days",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "14days",
  },
  {
    label: window.sys_app_translate(
      "1 Month",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "1month",
  },
  {
    label: window.sys_app_translate(
      "2 Month",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "2months",
  },
  {
    label: window.sys_app_translate(
      "3 Month",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "3months",
  },
  {
    label: window.sys_app_translate(
      "4 Months",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "4months",
  },
  {
    label: window.sys_app_translate(
      "6 Months",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "6months",
  },
  {
    label: window.sys_app_translate(
      "1 Year",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "1year",
  },
];

export const HealthPolicyTermsItems = [
  {
    id: 1,
    icon: <></>,
    text: "1 Year",
  },
  {
    id: 2,
    icon: <></>,
    text: "2 Year",
  },
  {
    id: 3,
    icon: <></>,
    text: "3 Year",
  },
];

export const IdTypeItems1 = [
  {
    id: 1,
    icon: <></>,
    text: "Passport",
  },
  {
    id: 2,
    icon: <></>,
    text: "Turkish ID",
  },
];

export const ProcessingModes = [
  {
    value: 0,
    label: window.sys_app_translate(
      "Auto Mode",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
  },
  {
    value: 1,
    label: window.sys_app_translate(
      "Manual Mode",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
  },
];

export const ProcessTypes = [
  {
    value: "new",
    label: window.sys_app_translate(
      "New",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
  },
  {
    value: "renewal",
    label: window.sys_app_translate(
      "Renewal",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
  },
];

export const Destinations = [
  {
    label: window.sys_app_translate(
      "AVRUPA VE SCHENGEN DAHİL (TÜRKİYE HARİÇ)",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "AVRUPA VE SCHENGEN DAHİL (TÜRKİYE HARİÇ)",
  },
  {
    label: window.sys_app_translate(
      "TÜM DÜNYA (TÜRKİYE VE KKTC HARİÇ)",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "TÜM DÜNYA (TÜRKİYE VE KKTC HARİÇ)",
  },
  {
    label: window.sys_app_translate(
      "TÜRKİYE",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "TÜRKİYE",
  },
  {
    label: window.sys_app_translate(
      "(AVRUPA) ÖĞRENCİ ve ÇALIŞAN YURTDIŞI SÜRE BOYU SİGORTASI",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "(AVRUPA) ÖĞRENCİ ve ÇALIŞAN YURTDIŞI SÜRE BOYU SİGORTASI",
  },
  {
    label: window.sys_app_translate(
      "(TÜM DÜNYA) ÖĞRENCİ ve ÇALIŞAN YURTDIŞI SÜRE BOYU SİGORTASI",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "(TÜM DÜNYA) ÖĞRENCİ ve ÇALIŞAN YURTDIŞI SÜRE BOYU SİGORTASI",
  },
];

export const VehicleUsageTypes = [
  {
    id: "Car",
    icon: <></>,
    text: window.sys_app_translate(
      "Car",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
  },
  {
    id: "Van",
    icon: <></>,
    text: window.sys_app_translate(
      "Van",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
  },
  {
    id: "Minibus",
    icon: <></>,
    text: window.sys_app_translate(
      "Minibus",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
  },
  {
    id: "Bus",
    icon: <></>,
    text: window.sys_app_translate(
      "Bus",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
  },
  {
    id: "Motorcycle",
    icon: <></>,
    text: window.sys_app_translate(
      "Motorcycle",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
  },
];

export const YesNoTypes = [
  {
    id: "Yes",
    icon: <></>,
    text: "Yes",
  },
  {
    id: "No",
    icon: <></>,
    text: "No",
  },
];

export const HasPlateTypes = [
  {
    id: "Yes",
    icon: <></>,
    text: "Yes",
  },
  {
    id: "No",
    icon: <></>,
    text: "No",
  },
];

export const PlateTypes = [
  {
    id: "Local",
    icon: <></>,
    text: "Turkish Plate",
  },
  {
    id: "NoPlate",
    icon: <></>,
    text: "No Plate",
  },
  {
    id: "Foreign",
    icon: <></>,
    text: "Foreign Plate",
  },
];

export const CarBrands = [
  { label: "Toyota", value: "Toyota" },
  { label: "Mercedes-Benz", value: "Mercedes-Benz" },
  { label: "BMW", value: "BMW" },
  { label: "Volkswagen", value: "Volkswagen" },
  { label: "Ford", value: "Ford" },
  { label: "Audi", value: "Audi" },
  { label: "Honda", value: "Honda" },
  { label: "Nissan", value: "Nissan" },
  { label: "Hyundai", value: "Hyundai" },
  { label: "Kia", value: "Kia" },
  { label: "Renault", value: "Renault" },
  { label: "Peugeot", value: "Peugeot" },
  { label: "Fiat", value: "Fiat" },
  { label: "Skoda", value: "Skoda" },
  { label: "Seat", value: "Seat" },
  { label: "Opel", value: "Opel" },
  { label: "Volvo", value: "Volvo" },
  { label: "Mazda", value: "Mazda" },
  { label: "Mitsubishi", value: "Mitsubishi" },
  { label: "Suzuki", value: "Suzuki" },
];

export const BuildingStyles = [
  {
    id: "ÇELİK,BETONARME,KARKAS YAPILAR",
    icon: <></>,
    text: "ÇELİK,BETONARME,KARKAS YAPILAR",
  },
  {
    id: "DİĞER YAPILAR",
    icon: <></>,
    text: "DİĞER YAPILAR",
  },
];
export const BuildingStylesForSelect = [
  {
    label: window.sys_app_translate(
      "ÇELİK,BETONARME,KARKAS YAPILAR",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "ÇELİK,BETONARME,KARKAS YAPILAR",
  },
  {
    label: window.sys_app_translate(
      "DİĞER YAPILAR",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "DİĞER YAPILAR",
  },
];

export const InsuredValues = [
  {
    id: "No Insurances",
    icon: <></>,
    value: "No Insurances",
  },
  {
    id: "Owner",
    icon: <></>,
    value: "Owner",
  },
  {
    id: "Tenant",
    icon: <></>,
    value: "Tenant",
  },
  {
    id: "Other",
    icon: <></>,
    value: "Other",
  },
];
export const InsuredValuesForSelect = [
  {
    label: window.sys_app_translate(
      "No Insurances",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "No Insurances",
  },
  {
    label: window.sys_app_translate(
      "Owner",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Owner",
  },
  {
    label: window.sys_app_translate(
      "Tenant",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Tenant",
  },
  {
    label: window.sys_app_translate(
      "Other",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Other",
  },
];

export const UsageStyles = [
  {
    id: "MESKEN",
    icon: <></>,
    text: "MESKEN",
  },
  {
    id: "TİCARETHANE",
    icon: <></>,
    text: "TİCARETHANE",
  },
  {
    id: "DİĞER",
    icon: <></>,
    text: "DİĞER",
  },
];
export const UsageStylesForSelect = [
  {
    label: window.sys_app_translate(
      "MESKEN",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "MESKEN",
  },
  {
    label: window.sys_app_translate(
      "TİCARETHANE",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "TİCARETHANE",
  },
  {
    label: window.sys_app_translate(
      "DİĞER",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "DİĞER",
  },
];

export const DamageStatuses = [
  {
    id: "Hasarsız",
    icon: <></>,
    text: "Hasarsız",
  },
  {
    id: "Az Hasarlı",
    icon: <></>,
    text: "Az Hasarlı",
  },
  {
    id: "Orta Hasarlı",
    icon: <></>,
    text: "Orta Hasarlı",
  },
];
export const DamageStatusesForSelect = [
  {
    label: window.sys_app_translate(
      "Hasarsız",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Hasarsız",
  },
  {
    label: window.sys_app_translate(
      "Az Hasarlı",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Az Hasarlı",
  },
  {
    label: window.sys_app_translate(
      "Orta Hasarlı",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Orta Hasarlı",
  },
];

export const NumberOfFloors = [
  {
    id: "1-3 KAT ARASI",
    icon: <></>,
    text: "1-3 KAT ARASI",
  },
  {
    id: "4-7 KAT ARASI",
    icon: <></>,
    text: "4-7 KAT ARASI",
  },
  {
    id: "8-18 ARASI KAT",
    icon: <></>,
    text: "8-18 ARASI KAT",
  },
  {
    id: "19 VE ÜZERİ KATLAR",
    icon: <></>,
    text: "19 VE ÜZERİ KATLAR",
  },
];
export const NumberOfFloorsForSelect = [
  {
    label: window.sys_app_translate(
      "1-3 KAT ARASI",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "1-3 KAT ARASI",
  },
  {
    label: window.sys_app_translate(
      "4-7 KAT ARASI",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "4-7 KAT ARASI",
  },
  {
    label: window.sys_app_translate(
      "8-18 ARASI KAT",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "8-18 ARASI KAT",
  },
  {
    label: window.sys_app_translate(
      "19 VE ÜZERİ KATLAR",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "19 VE ÜZERİ KATLAR",
  },
];

export const BuildingYears = [
  {
    label: window.sys_app_translate(
      "1975 VE ÖNCESİ",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "1975 VE ÖNCESİ",
  },
  {
    label: "1976-1999",
    value: "1976-1999",
  },
  {
    label: "2000-2006",
    value: "2000-2006",
  },
  {
    label: "2007-2018",
    value: "2007-2018",
  },
  {
    label: "2019 VE SONRASI",
    value: "2019 VE SONRASI",
  },
];

export const RelationshipTypes = [
  {
    label: window.sys_app_translate(
      "Spouse",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Spouse",
  },
  {
    label: window.sys_app_translate(
      "Child",
      OfflineStorage.instance.get("esitqapp-lang"),
    ),
    value: "Child",
  },
];
